import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { revaluation as rules } from 'further-ui/validations';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Revaluation } from '../types';

type InvestmentHistory = NonNullable<
  rules.RevaluationFormType['investmentHistory']
>;
type NewRevaluations = rules.RevaluationFormType['newRevaluations'];
type AssetWithBaseCurrency = { baseCurrency?: CurrencyCode };

type UseRevaluationFormProps = {
  investmentHistory: InvestmentHistory;
  revaluations: Array<Omit<Revaluation, 'isNew'>>;
  asset: AssetWithBaseCurrency;
  newRevaluations: NewRevaluations;
  initialRevaluationDate?: Date;
};

export const useRevaluationForm = ({
  investmentHistory,
  revaluations,
  asset,
  newRevaluations,
  initialRevaluationDate,
}: UseRevaluationFormProps) => {
  const defaultValues: rules.RevaluationFormType = {
    revaluations: revaluations.map((rev) => ({
      ...rev,
      isNew: false as const,
    })),
    assetCurrency: asset.baseCurrency ?? CurrencyCode.GBP,
    newRevaluations,
    investmentHistory,
    currentUnitPrice: 0,
    currentHoldValue: 0,
    currentRevaluationDate: initialRevaluationDate,
  };

  const formMethods = useForm({
    shouldFocusError: true,
    resolver: zodResolver(rules.RevaluationFormSchema),
    defaultValues,
    criteriaMode: 'all',
    resetOptions: {
      keepDefaultValues: false,
    },
  });

  return formMethods;
};
